import { render, staticRenderFns } from "./shop-card.vue?vue&type=template&id=7361600c&scoped=true&"
import script from "./shop-card.vue?vue&type=script&lang=js&"
export * from "./shop-card.vue?vue&type=script&lang=js&"
import style0 from "./shop-card.vue?vue&type=style&index=0&id=7361600c&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7361600c",
  null
  
)

export default component.exports